import React, { useState, useEffect, useRef } from "react";

import Animate from "../Animate/Animate";
import FixedBanner from "../FixedBanner/FixedBanner";
import Image from "../Image";
import Timer from "../Timer/Timer";

import "./Landing.css";

function useInView(ref) {
  const [displayStatus, setDisplayStatus] = useState("none");

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setDisplayStatus(entry.isIntersecting ? "none" : "block");
      },
      { threshold: 0.01 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref]);

  return displayStatus;
}

export default function Landing() {
  const refA = useRef();
  const isInViewA = useInView(refA);
  return (
    <>
      <section
        ref={refA}
        style={{
          overflow: "hidden",
        }}
      >
        <div className="div_block_2">
          <div className="div_block_3">
            <h1 className="heading">
              A Proven Program To
              <br /> Get You a <Animate />
            </h1>
            <picture>
              <source
                media="(max-width:479px)"
                loading="lazy"
                srcSet="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/underline_job_mobile.png"
              />
              <Image
                loading="lazy"
                src="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/underline_job_desktop.png"
                style={{ width: "auto" }}
                alt="underline-job"
              />
            </picture>
            <div className="ul_par">
              <div className="item">
                <div className="list_icon" />
                <div className="list_text">
                  <span>Trainers</span> are from Amazon and Microsoft
                </div>
              </div>
              <div className="item">
                <div className="list_icon" />
                <div className="list_text">
                  Placement opportunities from a pool of{" "}
                  <span>3000+ companies</span>
                </div>
              </div>
              <div className="item">
                <div className="list_icon" />
                <div className="list_text">
                  <span>10+ Real-time projects</span> that make your
                  <br />
                  resume strong
                </div>
              </div>
              <div className="item">
                <div className="list_icon" />
                <div className="list_text ">
                  AI-Powered <span> Mock Interviews</span>
                </div>
              </div>
            </div>
          </div>
          <div className="div_block_4" id="book-my-session">
            <div className="form_bg_hc_bd">
              <div className="form_bg_hc"> </div>
            </div>
            <div className="div_block_5">
              <div className="div_block_6">
                <div className="text_block">
                  Book a <span style={{ color: "#ea580c" }}>Free</span> Live
                  Session
                </div>
                <Image
                  src="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/demo-form-icon.png"
                  loading="lazy"
                  width={92}
                  height={88}
                  alt="Free-Session"
                  className="image"
                />
              </div>
              <div
                id="book-a-free-session"
                style={{ minHeight: "470px" }}
              ></div>
              <Timer imgTxt={"form"} txtColor={"#ea580c"} />
            </div>
          </div>
        </div>
      </section>
      <div className="fixed_s" style={{ display: `${isInViewA}` }}>
        <FixedBanner />
      </div>
    </>
  );
}
